export default __webpack_public_path__ + "static/media/thank-you-mobile.55eeb7fc.jpg";